import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AllBookPage from '../AllData/AllBookPage';
import './Style/OnlineReadBook.css';

// Lazy Image component with cache-handling loader
const QuestionImage = ({ src, alt, className = "lazy-image" }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // Reset loader state whenever the source image changes
    setIsLoaded(false);

    // Cache Check: If the browser already has the image loaded from cache
    if (imgRef.current && imgRef.current.complete) {
      setIsLoaded(true);
    }
  }, [src]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className="image-wrapper">
      {!isLoaded && (
        <div className="loader-container">
          <div className="circle-loader" />
        </div>
      )}

      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={`${className} ${isLoaded ? 'loaded' : ''}`}
        onLoad={handleLoad}
        loading="lazy"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = 'https://placehold.co/600x800?text=Page+Not+Found';
          setIsLoaded(true); // Stop loader even on error
        }}
      />
    </div>
  );
};

const OnlineReadBook = () => {
  const { type, subject, topic } = useParams();
  const navigate = useNavigate();

  const matchingPages = AllBookPage.filter(
    (book) =>
      book.type?.toLowerCase() === type?.toLowerCase() &&
      book.subject?.toLowerCase() === subject?.toLowerCase() &&
      book.topic?.toLowerCase() === topic?.toLowerCase()
  );

  return (
    <div style={styles.container}>
      <div style={styles.pagesSection}>
        {matchingPages.length > 0 ? (
          <div className="image-row-container">
            {matchingPages.map((page) => (
              /* Removed the nested wrapper div here to prevent layout/loading visual bugs */
              <QuestionImage
                key={page._id.$oid}
                src={`/bookimg/${page.pagename}.jpg`}
                alt={page.pagename}
                className="lazy-image"
              />
            ))}
          </div>
        ) : (
          <div style={styles.noPages}>
            <p>No matching pages found for this selection.</p>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0px',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  pagesSection: {
    marginTop: '35px',
    marginBottom: "35px",
    marginLeft:"3px",
    marginRight: "3px",
  },
  noPages: {
    padding: '100px 20px',
    textAlign: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    color: '#718096',
    border: '1px dashed #d2d6da',
  }
};

export default OnlineReadBook;